<script lang="ts">

    import AppLayout from "@/layouts/AppLayout.svelte";
    import {Schedular} from "@/components/scheduler/index.js";
    import {SvelteDate} from "svelte/reactivity";
    import type { SchedularVehicle } from "/scheduler/types";
    import type { Field } from '@/types/types';
    import { page } from '@inertiajs/svelte';

    type Props = {
        schedularVehicles: SchedularVehicle[];
        displayDate?: string | null;
        highlightedAssignmentId?: string | null;
        jobTypeField?: Field | null;
        purposeField?: Field | null;
    };

    let {schedularVehicles, displayDate, highlightedAssignmentId, jobTypeField = null, purposeField = null}: Props = $props();

    let breadcrumbs = $state([
        {title: 'Schedular', href: route('schedular.index')},
    ]);

    let actionbuttons = $state([]);

    let baseUrl = route('web-api.Vehicle.schedular');
    // Get CSRF token from Inertia page props
    let csrfToken = $page.props.csrfToken || '';
    let readonlyPlanner = false;

    let startingDate = new SvelteDate()
    startingDate.setMonth(startingDate.getMonth() - 2)
    let endingDate = new SvelteDate()
    endingDate.setMonth(new SvelteDate().getMonth() + 2)

    // Parse displayDate from query parameter if provided
    let initialDisplayDate: SvelteDate | undefined = undefined;
    if (displayDate) {
        const parsed = new Date(displayDate);
        if (!isNaN(parsed.getTime())) {
            initialDisplayDate = new SvelteDate(parsed);
        }
    }

</script>


<svelte:head>
    <title>Jobs</title>
    <style>
        body { overflow: hidden !important; }
    </style>
</svelte:head>

<!--<HeaderActionButtons>-->
<!--    {#if meta.user?.view_type === 'super-admin' || meta.user?.view_type === 'supervisory-body'}-->
<!--        <Button href={route('assessors.create')}>Add New Assessor</Button>-->
<!--    {/if}-->

<!--</HeaderActionButtons>-->
<AppLayout {breadcrumbs} {actionbuttons} {csrfToken}>
<!--    <section use:dndzone={{items}} onconsider={handleSort} onfinalize={handleSort}>-->
<!--        {#each items as item(item.id)}-->
<!--            <div data-id={item.id}>-->
<!--                {item.title}-->
<!--            </div>-->
<!--        {/each}-->
<!--    </section>-->

    <!--    <div class="svelte-wrapper"></div>    <div class="svelte-wrapper"></div>-->

</AppLayout>
<div class="mt-1 overflow-hidden">
    <Schedular {baseUrl} {csrfToken} {schedularVehicles} {readonlyPlanner} {startingDate} {endingDate} {initialDisplayDate} {highlightedAssignmentId} {jobTypeField} {purposeField}/>
</div>

